/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  error: 'sdfsdf',
  loading: false,
  move_taktarea_start_variables: {},
  // taktareas: {}
});

// State object
const state = initialState();
// Getter functions
const getters = {
  //Getters to local state
  getMoveTaktareaStartVariables: (state) => {
    return state.move_taktarea_start_variables;
  },
  isLoading: ( state ) => state.loading,


  //Getters to Ultra Store state
  getTaktareaLength: (state, getters, rootState) => (taktarea_id) => {
    return rootState.Ultra.taktareas[taktarea_id].taktarea_start + rootState.Ultra.taktareas[taktarea_id].twaggons.length;
  },
  getHistTaktareaLength: (state, getters, rootState) => (taktarea_id) => {
    return rootState.Ultra.histtaktareas[taktarea_id].taktarea_start + rootState.Ultra.histtaktareas[taktarea_id].histtwaggons.length;
  },
  getQRCodes: (state, getters, rootState) => (payload) => {
    if (rootState.Ultra.taktareas[payload.taktarea_id] && rootState.Ultra.taktareas[payload.taktarea_id].tags) {
      let tags = [];
      // get QR Codes of twork_package_loading
      rootState.Ultra.taktareas[payload.taktarea_id].tags.forEach((tag_id) => {
        let tag = JSON.parse(JSON.stringify(rootState.Ultra.tags[tag_id]));
        tag.person_string = `${tag.user_email.last_name}, ${tag.user_email.first_name}`;
        let date = new Date(tag.created.split(' UTC')[0]);
        let date_string =
        rootState.Ultra.week_days_full[date.getDay()] + ', ' +
        date.getDate() + '. ' +
        rootState.Ultra.months[date.getMonth()] + ' ' +
        date.getFullYear();
        tag.date_string = date_string;
        tags.push(tag);
      });
      // filter QR Codes by payload.filter and payload.search
      let sort_key;
      let is_reversed;
      if(payload.filter == 'Latest') {
        tags = tags.filter(qr =>
          qr.description.toLowerCase().includes(payload.search.toLowerCase()) ||
          qr.date.toLowerCase().includes(payload.search.toLowerCase()) ||
          qr.user_email.first_name.toLowerCase().includes(payload.search.toLowerCase()) ||
          qr.user_email.last_name.toLowerCase().includes(payload.search.toLowerCase()) ||
          qr.user_email.email.toLowerCase().includes(payload.search.toLowerCase())
        );
        sort_key = 'created';
        is_reversed = true;
      }
      else if(payload.filter == 'Description') {
        tags = tags.filter(qr => qr.description.toLowerCase().includes(payload.search.toLowerCase()));
        sort_key = 'description';
      }
      else if(payload.filter == 'Date') {
        tags = tags.filter(qr => qr.created.toLowerCase().includes(payload.search.toLowerCase()));
        sort_key = 'created';
        is_reversed = true;
      }
      else if(payload.filter == 'Person') {
        tags = tags.filter(qr => qr.person_string.toLowerCase().includes(payload.search.toLowerCase()));
        sort_key = 'person_string';
      }
      getters.sortObjectArrayByValueOfKey({array: tags, sort_key});
      if(is_reversed) {
        tags.reverse();
      }
      if(!tags.length) {
        return [];
      }
      // cathegroize tags by payload.filter
      let qr_code_arr = [];
      let arr_idx = -1;
      switch (payload.filter) {
        case 'Description':
        for(let i = 0; i < tags.length; i++) {
          if(
            qr_code_arr[arr_idx] &&
            tags[i].description[0].toUpperCase() === qr_code_arr[arr_idx].category
          ) {
            qr_code_arr[arr_idx].data.push(tags[i]);
          }
          else {
            arr_idx++;
            qr_code_arr.push({
              category: tags[i].description[0].toUpperCase(),
              data: [tags[i]]
            });
          }
        }
        return qr_code_arr;
        case 'Date':
        for(let i = 0; i < tags.length; i++) {
          if(
            qr_code_arr[arr_idx] &&
            tags[i].date_string === qr_code_arr[arr_idx].category
          ) {
            qr_code_arr[arr_idx].data.push(tags[i]);
          }
          else {
            arr_idx++;
            qr_code_arr.push({
              category: tags[i].date_string,
              data: [tags[i]]
            });
          }
        }
        return qr_code_arr;

        case 'Person':
        for(let i = 0; i < tags.length; i++) {
          if(
            qr_code_arr[arr_idx] &&
            tags[i].person_string === qr_code_arr[arr_idx].category
          ) {
            qr_code_arr[arr_idx].data.push(tags[i]);
          }
          else {
            arr_idx++;
            qr_code_arr.push({
              category: tags[i].person_string,
              data: [tags[i]]
            });
          }
        }
        return qr_code_arr;
        default:
        return [{ category: '', data: tags }];
      }

    }
    return [{ category: '', data: [] }];
  },
  sortObjectArrayByValueOfKey: () => (payload) => {
    payload.array.sort((a, b) => {
      // we check every char if they're the same, if not sort accordingly
      // TODO: check for ö, ä, ü, ß
      let min = Math.min(a[payload.sort_key].length, b[payload.sort_key].length);
      for(let i = 0; i < min; i++) {
        if(a[payload.sort_key][i].toLowerCase() !== b[payload.sort_key][i].toLowerCase()) {
          return a[payload.sort_key][i].toLowerCase() > b[payload.sort_key][i].toLowerCase() ? 1 : -1;
        }
      }
      // all chars were the same, shorter string is prioritized
      if(a[payload.sort_key].length != b[payload.sort_key].length) {
        return a[payload.sort_key].length === min ? -1 : 1;
      }
      // string matches exactly, no preference
      return 0;
    });
  },
  getTaktarea: (state, getters, rootState) => (taktarea_id) => {
    return rootState.Ultra.taktareas[taktarea_id];
  },
  getTaktareas: (state, getters, rootState) => (payload) => {
    if (payload.ids) {
      return payload.ids.map(id => rootState.Ultra.taktareas[id]);
    } else {
      return Object.keys(rootState.Ultra.taktareas).map(id => rootState.Ultra.taktareas[id]);
    }
  },
};
// Actions
const actions = {
  //local taktarea variables
  setMoveTaktareaStartVariables({commit}, payload) {
    commit('set_move_taktarea_start_variables', payload);
  },
  addTATag({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'projects/' + payload.project_id + '/trains/' + payload.train_id + '/taktareas/' + payload.taktarea_id + '/addtag' ,
        method: 'PUT',
        data: payload.data
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject(err.response.data.error_msg);
      });
    });
  },
  createQRCode({dispatch}, payload){
    dispatch('Ultra/createUObject', {
      url: [
        {projects: payload.project_id},
        {trains: payload.train_id},
        {taktareas: payload.taktarea_id},
        {tags: ''},
        {showWithEntitiesNormalized: ''},
      ],
      u_object: payload.code
    }, {root:true});
  },
  deleteQRCode({commit, rootState}, payload){
    return new Promise((resolve) => {
      axios({
        url: 'projects/' + payload.project_id + '/tags/' + payload.tag.id,
        method: 'DELETE',
        headers: {
          'Cache-Control': 'no-cache'
        },
        data: {
          edit_key: rootState.Project.edit_key
        }
      })
      .then(() => {
        commit('remove_tag', {rootState, payload});
        resolve();
      }).catch((err) => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      });
    });
  },
  //special taktarea actions with Ultra store Mutations
  changeTaktAreaStartBulk() {
    // if (payload.taktarea_index-1 !== rootState.Ultra.trains[payload.train_id].taktareas.length -1) {
    //   let update_start_bulk = [];
    //   let difference = rootGetters['TaktArea/getTaktarea'](rootState.Ultra.trains[payload.train_id].taktareas[payload.taktarea_index]).taktarea_start - payload.taktarea_start;
    //   for (let i = payload.taktarea_index; i < rootState.Ultra.trains[payload.train_id].taktareas.length; i++) {
    //     let new_taktarea_start = rootGetters['TaktArea/getTaktarea'](rootState.Ultra.trains[payload.train_id].taktareas[i]).taktarea_start - difference;
    //     update_start_bulk.push({
    //       taktarea_id: rootState.Ultra.trains[payload.train_id].taktareas[i],
    //       new_taktarea_start: new_taktarea_start,
    //     });
    //     axios({
    //       url: 'projects/' + payload.project_id +
    //       '/trains/' + payload.train_id +
    //       '/taktareas/' + rootState.Ultra.trains[payload.train_id].taktareas[i],
    //       method: 'PUT',
    //       data: {
    //         taktarea_start: new_taktarea_start,
    //         edit_key: edit_key,
    //       }
    //     });
    //   }
    //   commit('TaktArea/set_taktarea_start_bulk', {rootState, payload: {data: update_start_bulk}},{root: true});
    // }
  },
};
// Mutations
const mutations = {
  //local state mutations
  set_move_taktarea_start_variables(state, payload) {
    state.move_taktarea_start_variables = Object.assign(state.move_taktarea_start_variables, payload);
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err) {
    state.error = err;
  },
  taktarea_loading(state, loading) {
    state.loading = loading;
  },
  //Ultra store state mutation
  taktarea_change_value(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.taktareas[payload.taktarea_id], `${payload.value_name}`, payload.value);
  },
  twaggon_change_position(state, {rootState, payload}) {
    let twaggons = rootState.Ultra.taktareas[payload.taktarea_id].twaggons;
    twaggons.splice(payload.drag_evt.newIndex, 0, twaggons.splice(payload.drag_evt.oldIndex, 1)[0]);
  },
  twaggon_insert(state, {rootState, payload}) {
    rootState.Ultra.taktareas[payload.taktarea_id].twaggons.splice(payload.twaggon_index, 0, payload.id);
  },
  twaggon_delete(state, {rootState, payload}) {
    rootState.Ultra.taktareas[payload.taktarea_id].twaggons.splice(payload.twaggon_index, 1);
  },
  set_taktarea_start(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.taktareas[payload.taktarea_id], 'taktarea_start', payload.new_taktarea_start);
  },
  set_taktarea_start_bulk(state, {rootState, payload}) {
    for (let i = 0; i < payload.data.length; i++) {
      Vue.set(rootState.Ultra.taktareas[payload.data[i].taktarea_id], 'taktarea_start', payload.data[i].new_taktarea_start);
    }
  },
  taktarea_delete(state, {rootState, payload}) {
    Vue.delete(rootState.Ultra.taktareas, payload.taktarea_id);
  },
  taktareas_success(state, {rootState, payload}) {
    Vue.set(rootState, 'taktareas', Object.assign({}, rootState.Ultra.taktareas, payload));
  },
  taktareas_insert_bulk(state, {rootState, payload}) {
    Vue.set(rootState.Ultra, 'taktareas', Object.assign({}, rootState.Ultra.taktareas, payload));
  },
  add_tag_to_taktarea(state, {rootState, payload}) {
    rootState.Ultra.taktareas[payload.taktarea_id].tags.push(payload.id);
  },
  remove_tag(state, {rootState, payload}) {
    Vue.delete(rootState.Ultra.tags, payload.tag.id);
    payload.tag.link_type = payload.tag.link_type.toLowerCase();
    let index_wp = rootState.Ultra.taktareas[payload.tworkpackage_id].tags.indexOf(payload.tag.id);
    rootState.Ultra.taktareas[payload.tworkpackage_id].tags.splice(index_wp, 1);
    let index = rootState.Ultra[payload.tag.link_type][payload.tag.link_id].tags.indexOf(payload.tag.id);
    if (index != -1){
      rootState.Ultra[payload.tag.link_type][payload.tag.link_id].tags.splice(index, 1);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
